import React from 'react';

export interface TableBodyProps extends React.HTMLAttributes<HTMLTableSectionElement> {
  children: React.ReactNode;
  className?: string;
}

const TableBody = ({ children, className = '', ...props }: TableBodyProps) => (
  <tbody className={className} {...props}>
    {children}
  </tbody>
);

export default TableBody;
